import { useState } from "react";
import PrimaryButton from "../../../buttons/PrimaryButton";
import SecondaryButton from "../../../buttons/SecondaryButton";
import Dropzone3 from "../../../dropzones/DropZone3";
import ExtractionLoading from "../../../loading/ExtractionLoading";
import extractInfosFromFile from "../../../api/ai/extractInfosFromFile";
import { getOrRefreshFirebaseToken } from "../../../config/getFirebaseToken";
import Modal1 from "../../../modals/Modal1";

export default function NewFolderExtractionFromFile({
  onClose,
  prefix,
  setNom,
  setPrenom,
  setAdresse,
  setVille,
  setPostal,
  handleClickVariant,
  onFileExtracted,
}) {
  const [droppedFiles, setDroppedFiles] = useState([]);
  const [selectedFiles, setSelectedDroppedFiles] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);

  const [extracting, setExtracting] = useState(false);
  const handleExtractInfosFromFile = async (file) => {
    setExtracting(true);
    // Implement your logic to extract information from the file using AI
    const token = await getOrRefreshFirebaseToken();
    let res = await extractInfosFromFile(file, token, prefix);
    if (res) {
      setNom(res.maitre_ouvrage_name || "");
      setPrenom(res.maitre_ouvrage_first_name || "");
      setAdresse(res.address || "");
      setVille(res.city || "");

      setPostal(res.postal || "");

      if (onFileExtracted) {
        onFileExtracted(file);
      }
      handleClickVariant("Informations extraites avec succès", "success");
    } else {
      handleClickVariant("Impossible d'extraire les informations", "error");
    }
    onClose();
    setExtracting(false);
  };

  return (
    <Modal1 isOpen={true} onClose={onClose}>
      <div className="p-2 shadow-cyan-300  shadow-md bg-gradient-to-br  rounded-4xl from-cyan-200 to-indigo-400">
        {extracting ? (
          <div className="bg-white flex flex-col w-fit rounded-3xl  ">
            <ExtractionLoading delay={8}></ExtractionLoading>
          </div>
        ) : (
          <div className="bg-white flex flex-col w-c500 rounded-3xl  ">
            <div className="flex flex-col  w-full">
              <div className="border-b-1 p-4 text-h3">Extraction par IA</div>
              <div className="bg-neutral-50 p-4 flex flex-col">
                <div className="text-h3 text-shadow_50 mb-4">
                  Vous pouvez déposer un fichier pour que notre IA récupère
                  automatiquement les informations du projet.
                </div>
                <div className="text-h3 text-black font-semibold mb-4">
                  Seules les 2 premières pages du fichier seront analysées.
                </div>

                <Dropzone3
                  onDrop={(files) => {
                    setSelectedDroppedFiles(files);
                    setDroppedFiles(files);
                  }}
                  onDelete={(file) =>
                    setDroppedFiles(
                      droppedFiles.filter((f) => f.id !== file.id),
                    )
                  }
                  title="Glissez votre fichier ici"
                  loading={loadingDrop}
                  selected_files={selectedFiles}
                  setSelectedDroppedFiles={setSelectedDroppedFiles}
                  files={droppedFiles}
                ></Dropzone3>
              </div>
              <div className="flex flex-row gap-2 justify-between border-t-1 p-4">
                <SecondaryButton
                  className=" items-center justify-center"
                  onClick={() => {
                    onClose();
                  }}
                >
                  Continuer sans fichier
                </SecondaryButton>
                <PrimaryButton
                  className="min-w-fit"
                  sx={{ backgroundColor: "red" }}
                  onClick={() => {
                    handleExtractInfosFromFile(selectedFiles[0]);
                  }}
                >
                  Récupérer les informations
                </PrimaryButton>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal1>
  );
}
